<template>
  <div class="overflow-auto">
    <b-container class="container-narrow" v-if="!eventState">
      <div v-bind:class="{ 'd-none': currentPage == 3 }">
        <b-row class="mb-4">
          <b-col v-if="currentPage == 1">
            <div class="mb-5">
              <span class="text-xs text-teal"
                >Schritt {{ currentPage }}/{{ rows }}</span
              >

              <p class="h4">Gestalten</p>
            </div>

            <div class="mb-5 w-75">
              <h2>Design drauf los!</h2>

              <p>
                Auf geht’s: Wähle die Icons und den Text aus, die du für dein
                Design verwenden möchtest. Danach kannst Du die Größe skalieren
                und die Position auf deiner Hülle festlegen. Tob dich aus!
              </p>
            </div>

            <b-button v-b-modal.modal-text pill variant="primary" class="mb-4"
              >Mein Text</b-button
            >

            <br />

            <b-button v-b-modal.modal-icons pill variant="primary" class="mb-4"
              >Meine Icons</b-button
            >
          </b-col>

          <b-col v-if="currentPage == 2">
            <div class="mb-5">
              <span class="text-xs text-teal"
                >Schritt {{ currentPage }}/{{ rows }}</span
              >

              <p class="h4">Vorschau</p>
            </div>

            <div class="mb-5 w-75">
              <h2>So sieht's aus!</h2>

              <p>
                Das ist dein Design. Alles schick? Oder willst du noch was
                ändern? Klick einfach den entsprechenden Button.
              </p>
            </div>
          </b-col>

          <b-col v-if="currentPage == 4">
            <!-- <div class="mb-5">
              <span>Schritt {{ currentPage }}/{{ rows }}</span>

              <p class="h4">Fertig</p>
            </div>

            <div class="mb-5">
              <h2>Schön geworden!</h2>

              <p>
                Deine Feuerzeughülle wird bald bei dir sein! Dein Design wird
                jetzt bearbeitet und du bekommst dann die Versandbestätigung per
                Mail. Schön, dass du bei dieser Aktion dabei warst. Lust auf
                mehr aus der Welt von Camel? Gibt`s hier:
              </p>
            </div>

            <b-button
              href="https://lets-cml.de/category/now/"
              target="_parent"
              pill
              variant="primary"
              >Zum Blog</b-button
            > -->
          </b-col>

          <b-col cols="auto">
            <ItemizerCanvas
              v-if="this.event"
              :event="this.event"
              :currentPage="this.currentPage"
              ref="canvas"
            ></ItemizerCanvas>
          </b-col>
        </b-row>

        <b-row v-if="currentPage == 1" class="justify-content-between">
          <b-col cols="auto">
            <b-button pill variant="outline-light" v-on:click="resetCanvas"
              >Auf Anfang</b-button
            >
          </b-col>
          <b-col cols="auto">
            <b-button pill variant="primary" v-on:click="exportToPngAndContinue"
              >Und weiter</b-button
            >
          </b-col>
        </b-row>

        <b-row v-if="currentPage == 2" class="justify-content-between">
          <b-col cols="auto">
            <b-button pill variant="outline-light" v-on:click="firstStep"
              >Da fehlt noch was</b-button
            >
          </b-col>

          <b-col cols="auto">
            <b-button pill variant="primary" v-on:click="nextStep()"
              >Genau so soll das</b-button
            >
          </b-col>
        </b-row>
      </div>

      <div id="stepView3" v-if="currentPage == 3">
        <div class="mb-5">
          <span class="text-xs text-teal"
            >Schritt {{ currentPage }}/{{ rows }}</span
          >

          <p class="h4">Für wen?</p>
        </div>

        <div class="mb-5">
          <h2>Wo soll’s denn hingehen?</h2>

          <p>
            Fast fertig. Verrate uns nur noch, wohin wir deine Feuerzeughülle
            schicken sollen. Danke!
          </p>
        </div>

        <b-form @submit="submitDesign" class="form-narrow mx-auto">
          <b-form-group>
            <b-form-radio name="salutation" value="1" size="lg"
              >Herr</b-form-radio
            >

            <b-form-radio name="salutation" value="2" size="lg"
              >Frau</b-form-radio
            >

            <b-form-radio name="salutation" value="3" size="lg"
              >Divers</b-form-radio
            >
          </b-form-group>

          <mdb-input
            label="Vorname*"
            id="firstName"
            v-model.trim="firstName"
            type="text"
            name="first_name"
            required
          ></mdb-input>

          <mdb-input
            id="lastName"
            label="Nachname*"
            v-model.trim="lastName"
            type="text"
            name="last_name"
            required
          ></mdb-input>

          <mdb-input
            id="email"
            label="E-Mail Adresse*"
            v-model.trim="email"
            type="email"
            name="email"
            required
          ></mdb-input>
          <div class="md-form">
            <vue-google-autocomplete
              v-if="googleMapsScriptLoaded"
              ref="address"
              id="map"
              autocomplete="cml-g-a"
              classname="form-control"
              placeholder="Adresse eingeben"
              v-on:placechanged="getAddressData"
              v-on:error="handleGoogleAutocompleteError"
              country="de"
            >
            </vue-google-autocomplete>
          </div>

          <b-form-row>
            <b-col cols="9">
              <mdb-input
                id="street"
                label="Straße*"
                v-model.trim="street"
                type="text"
                name="address"
                required
              ></mdb-input>
            </b-col>

            <b-col cols="3">
              <mdb-input
                id="houseNumber"
                label="Nummer*"
                v-model.trim="houseNumber"
                type="text"
                name="street_number"
                required
              ></mdb-input>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col cols="4">
              <mdb-input
                id="postcode"
                label="PLZ*"
                v-model.trim="postcode"
                type="text"
                name="zip"
                required
              ></mdb-input>
            </b-col>

            <b-col cols="8">
              <mdb-input
                id="city"
                label="Ort*"
                v-model.trim="city"
                type="text"
                name="city"
                required
              ></mdb-input>
            </b-col>
          </b-form-row>

          <mdb-input
            id="phone"
            label="Telefon mobil"
            v-model.trim="phone"
            type="tel"
            name="phone"
          ></mdb-input>

          <b-form-group>
            <b-form-checkbox id="consent" name="consent" size="lg" required>
              <small>
                Hiermit bestätige ich, die
                <a href="http://teilnahmebedingungen.jti.de/" target="_parent"
                  >Teilnahmebedingungen</a
                >
                zu akzeptieren. Die Teilnahmebedingungen sind hier zu lesen:
                <a href="http://teilnahmebedingungen.jti.de/" target="_parent"
                  >http://teilnahmebedingungen.jti.de/</a
                >
              </small>
            </b-form-checkbox>
            <hr class="invisible" />
            <small class="font-italic">
              <p class="text-center">
                Die Aktion richtet sich nur an volljährige Raucher mit
                gemeldetem Wohnsitz in Deutschland. Teilnahmeschluss für die
                Aktion ist der 25.12.2020. Pro Person ist die Teilnahme nur
                einmal möglich. Die Gewinner werden unmittelbar nach der
                Auslosung informiert.
              </p>
            </small>
          </b-form-group>

          <b-row class="justify-content-center">
            <b-col cols="auto">
              <b-button
                type="submit"
                pill
                variant="primary"
                class="mb-4"
                :disabled="isLoading == true"
              >
                <b-spinner
                  class="mr-2 mb-1"
                  v-show="isLoading"
                  small
                ></b-spinner>
                {{ formSubmitButtonText }}
              </b-button>
            </b-col>
          </b-row>

          <p class="text-center">
            <small>*Pflichtfelder</small>
          </p>
        </b-form>
      </div>
    </b-container>
    <div v-else>
      <b-container
        class="container-narrow"
        v-html="event_inactive_message.value"
      ></b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ClientOAuth2 from "client-oauth2";
import sanitize from "sanitize-filename";
import ItemizerCanvas from "./ItemizerCanvas.vue";
import { mdbInput } from "mdbvue";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  components: {
    ItemizerCanvas,
    mdbInput,
    VueGoogleAutocomplete,
  },
  props: {
    event: String,
  },
  data() {
    return {
      rows: 4,
      perPage: 1,
      currentPage: 1,
      canvas: {},
      firstName: "",
      lastName: "",
      email: "",
      street: "",
      houseNumber: "",
      postcode: "",
      city: "",
      phone: "",
      isLoading: false,
      authToken: "",
      eventData: this.event,
      eventState: null,
      event_inactive_message: null,
      customer_id: null,
      placesAddress: null,
      googleMapsApiKey: "AIzaSyACLj6YzOV3_Xc_FnfcPxGFvEYZakOyL3w",
      googleMapsScriptLoaded: false,
    };
  },
  computed: {
    formSubmitButtonText: function () {
      if (this.isLoading == true) {
        return "Sendet...";
      }
      return "Und los!";
    },
  },
  mounted: function () {
    this.canvas = this.$refs.canvas;
    this.initAuthentication();
    const url = this.$apiBaseUrl + `/api/v1/events/${this.eventData}`;
    let self = this;
    axios.get(url).then((res) => {
      self.eventState = res.data.data.attributes.field_event_state;
      self.event_inactive_message =
        res.data.data.attributes.field_event_inactive_message;
    });
    this.customer_id = new URL(location.href).searchParams.get("customer_id");
    this.loadGoogleMapsSdk();
  },
  methods: {
    nextStep() {
      this.currentPage += 1;
      // Redirect to iframe Parent
      if (this.currentPage == 4) {
        window.top.location.href =
          "https://lets-cml.de/kreativ-gestaltet-sein-feuerzeug-selbst-success/";
      }
    },
    firstStep() {
      this.currentPage = 1;
    },
    exportToPngAndContinue() {
      this.canvas.exportToPng();
      this.nextStep();
    },
    initAuthentication() {
      let oAuthUrl = this.$apiBaseUrl + "/oauth/token";
      let drupalAuth = new ClientOAuth2({
        clientId: "af5a3d18-12d9-4e54-bb3c-1a7f2aad221d",
        clientSecret: "MLVJ3g(%$Q~",
        accessTokenUri: oAuthUrl,
      });
      let self = this;
      drupalAuth.owner
        .getToken("api_user_frontend_client", "nC3S@!w5U&B")
        .then(function (user) {
          // console.log(user); //=> { accessToken: '...', tokenType: 'bearer', ... }
          self.authToken = user.accessToken;
        })
        .catch((error) => {
          console.log(`Auth error: ${error}`);
        });
    },
    submitDesign(e) {
      e.preventDefault();
      this.isLoading = true;
      let self = this;
      this.canvas.getBlobFromCanvas().then(function (blob) {
        self.sendDataAndContinue(blob);
      });
    },
    sendDataAndContinue(userDesignBlob) {
      let self = this;
      const userData = {
        data: {
          type: "node--item",
          attributes: {
            title: "My custom title",
            body: {
              value: "Customer item",
              format: "plain_text",
            },
            field_customer_id: this.customer_id,
            address: {
              langcode: "",
              country_code: "DE",
              administrative_area: null,
              locality: this.city,
              dependent_locality: null,
              postal_code: this.postcode,
              sorting_code: null,
              address_line1: this.street,
              address_line2: this.houseNumber,
              organization: null,
              given_name: this.firstName,
              additional_name: null,
              family_name: this.lastName,
            },
            email: this.email,
            phone: this.phone,
          },
          relationships: {
            field_item_type: {
              data: {
                type: "taxonomy_term--item_type",
                id: "00865398-e153-4600-b37a-6f80a3d6837d",
              },
            },
            field_event: {
              data: {
                type: "node--event",
                id: this.eventData,
              },
            },
          },
        },
      };

      const url = `${self.$apiBaseUrl}/api/v1/items`;
      const options = {
        headers: {
          "Content-Type": "application/vnd.api+json",
        },
      };
      // const token =
      //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjQ2Zjk5YzE0ZGYyZDRkZDVkYmU3ZTdkNDAyZGFjMmE5YzFkMjQ1ZTdkMzU2MjQ0MTE3ZGI4NjAyYzJkYjc3OWEzYWZlYmMxNWMzYjgwNWMyIn0.eyJhdWQiOiI1OTllMmM1ZS1lMTk5LTQ5OTItODAwOS1kZjZlM2Y5OGQ4NzQiLCJqdGkiOiI0NmY5OWMxNGRmMmQ0ZGQ1ZGJlN2U3ZDQwMmRhYzJhOWMxZDI0NWU3ZDM1NjI0NDExN2RiODYwMmMyZGI3NzlhM2FmZWJjMTVjM2I4MDVjMiIsImlhdCI6MTYwMDc3OTMwNSwibmJmIjoxNjAwNzc5MzA1LCJleHAiOjE2MDEzODQxMDQsInN1YiI6IjEiLCJzY29wZXMiOlsiYXV0aGVudGljYXRlZCIsImFwaV91c2VyIl19.l5hEe_BqwD8bYRdPeK9C0B-6TTp0uZVfa0WsUfO_tcAAfB_MsyWNqId7N-cJ7jxuVC3fdI_GMBOXoSdo5WlnN8E6mqlDIOSl5Qcjkv6UO5DZqiuqm5tNyDBbyvrcMVHQVWOIR-2dAu56FXiwuBNoXn8nYCLoHtYgMXnsDPJPKcKtzJOa6yNi5gsTgPCkStHyAcGdUXq5meD3fHXmMk-5Wj7dkXtkOOdgMSQjQLs7FfDfeg9EB-UbZVvHaPqrptI8MQTH7Yx9qQPetpCEzhFW3cHxMKdM7UlsVRjwAyu2ljhQ9KigwYVZp_Wzxmmo-f0oTCZR0045sgNOhPA1VPjxxRbxvtYUuKB88BK-rS1D76zRPBBE705Jn67_ao-zeSahM874sZceJxCA8tmUwUImBxLuRMnL0_5zC64q3ZWqpIshaTEO5-VDMhuWd5Iqu5MI0KhfEN8tc1RXtklEOZ-MkG8Xdmow0hOPTLNAdcyXlx9yjjG3vquYuIdAzQJNhjSMRbDBtyHrS46yqxtS3YCuCAN4Zm4DAZ1OSjgqFa3GIQr3nRGErhs1UxdEfHe6oHZ0XHto_K5kAvambK9kR5H1dlvMEHdCAMxF34D1AT_y-fKHsZ3_bG1eMLqfZsfxlDSrlFdYlUo1ceVKKK6ZizKsrH7l1m__5u9IsL8Lfd2_SBs";
      axios.defaults.headers.common = {
        Authorization: `Bearer ${self.authToken}`,
      };
      axios
        .post(url, userData, options)
        .then((res) => {
          let itemId = res.data.data.id;
          return itemId;
        })
        .then((id) => {
          // Because it seems not possible with Axios right now to sent binary data with the required Header "Content-Type:" "application/octet-stream"
          // i am using vanilla AJAX to post the image. Not nice but it works. See the following axios issues to read about the bug:
          // https://github.com/axios/axios/issues/2623
          // https://github.com/axios/axios/issues/86

          //   axios.interceptors.request.use(
          //     function (config) {
          //       console.log("axios config:", config);
          //       // Do something before request is sent
          //       config.headers["Content-Type"] = "application/octet-stream";
          //       config.headers.Test = "application/octet-stream";
          //       config.headers.common["Content-Type"] =
          //         "application/octet-stream";
          //       console.log("axios config after:", config);
          //       return config;
          //     },
          //     function (error) {
          //       // Do something with request error
          //       return Promise.reject(error);
          //     }
          //   );
          //   axios.post(
          //     `${self.$apiBaseUrl}/api/v1/items/${id}/field_user_design`,
          //     userDesignBlob,
          //     {
          //       headers: {
          //         "Content-Disposition": "file; filename='kf_vue_1.png'",
          //         "Content-Type": "application/octet-stream",
          //         Accept: "application/vnd.api+json",
          //       },
          //     }
          //   );

          var xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function () {
            console.log("this.readyState:", this.readyState);
            console.log("this.status:", this.status);
            if (this.readyState == 4 && this.status == 200) {
              // document.getElementById("demo").innerHTML = this.responseText;
              self.isLoading = false;
              self.nextStep();
            } else {
              if (this.readyState == 4 && this.status != 200) {
                self.isLoading = false;
                console.log(
                  `something went wrong. ajax state and status:  ${this.state} and ${this.status}`
                );
              }
            }
          };
          xhr.open(
            "POST",
            `${self.$apiBaseUrl}/api/v1/items/${id}/field_user_design`
          );
          xhr.setRequestHeader("Content-Type", "application/octet-stream");
          xhr.setRequestHeader(
            "Content-Disposition",
            `file; filename="${self.getFilename()}"`
          );
          xhr.setRequestHeader("Authorization", `Bearer ${self.authToken}`);
          xhr.send(userDesignBlob);
        });
    },
    getFilename() {
      let fileFirstname = this.firstName
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      let fileLastname = this.lastName
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      // (Sanitized and trimmed and spaces replaced by "_") <firstname>_<lastname>_<unixtimestamp>.png
      return `${sanitize(fileFirstname, "_")}_${sanitize(
        fileLastname,
        "_"
      )}_${new Date().getTime()}.png`
        .split(" ")
        .join("_");
    },
    resetCanvas() {
      this.canvas.resetCanvas();
      this.firstStep();
    },
    loadGoogleMapsSdk: function () {
      let self = this;
      let googleMapsScript = document.createElement("script");
      googleMapsScript.setAttribute(
        "src",
        `https://maps.googleapis.com/maps/api/js?key=${this.googleMapsApiKey}&libraries=places&callback=initMap`
      );
      googleMapsScript.async = true;
      document.head.appendChild(googleMapsScript);
      // Googleapi callback
      window.initMap = function () {
        // Trigger an event on the vm instance
        self.googleMapsScriptLoaded = true;
      };
    },
    // See https://github.com/olefirenko/vue-google-autocomplete
    getAddressData: function (addressData) {
      this.placesAddress = addressData;
      this.updateAdressFieldsFromGoogleAutocomplete();
    },
    updateAdressFieldsFromGoogleAutocomplete: function () {
      if (this.placesAddress.route) {
        this.street = this.placesAddress.route;
      }
      if (this.placesAddress.street_number) {
        this.houseNumber = this.placesAddress.street_number;
      }
      if (this.placesAddress.postal_code) {
        this.postcode = this.placesAddress.postal_code;
      }
      if (this.placesAddress.locality) {
        this.city = this.placesAddress.locality;
      }
    },
    handleGoogleAutocompleteError: function (error) {
      console.log("handleGoogleAutocompleteError:", error);
    },
  },
};
</script>
